import TemplateMessage from './TemplateMessage';

export default TemplateMessage;
